.overlay {
  position: absolute;
  z-index: 1;
  background-color: #1f2023cc;
  color: white;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
